import { newrelic } from "@jti/fe-clients";
import type { Address, AddressStored } from "@jti/fe-common";
import { CasAddressesApi } from "@jti/rest-api";

import { profileApiSlice } from "../profileApiSlice";
import type { ProfileApiBuilder } from "../profileApiSlice.types";
import { handleProfileApiError } from "../utils/handleProfileApiError";

type SaveAddressMutationPayload = AddressStored | Address;
type SaveAddressMutationResponse = {
  addresses: AddressStored[];
  address: AddressStored;
};

const hasDefaultShippingAddress = (addresses: AddressStored[]) =>
  addresses.some((address) => address.isDefaultShipping);

export const saveAddressEndpoint = (builder: ProfileApiBuilder) => ({
  saveAddress: builder.mutation<SaveAddressMutationResponse, SaveAddressMutationPayload>({
    queryFn: async (address) => {
      const casProfileApi = CasAddressesApi.init();

      try {
        const response = await casProfileApi.createAddress(address);

        if (!hasDefaultShippingAddress(response.addresses)) {
          try {
            await casProfileApi.setDefaultShippingAddress(response.address.id);
          } catch (error: unknown) {
            newrelic.noticeError(error as Error);
          }
        }

        return { data: response };
      } catch (error: unknown) {
        newrelic.noticeError(error as Error);

        return handleProfileApiError(error);
      }
    },
    onQueryStarted: async (address, { dispatch, queryFulfilled }) => {
      const patchResult = dispatch(
        profileApiSlice.util.updateQueryData("getProfile", undefined, (draft) => {
          if (!draft.addresses) {
            draft.addresses = [];
          }

          draft.addresses.unshift(address as AddressStored);
        })
      );
      try {
        await queryFulfilled;
      } catch {
        patchResult.undo();
      }
    },
  }),
});
